import { TextRegular } from 'UiKit/typography';
import AttachmentImage from 'Component/attachment-image';

import styles from './styles.module.css';
import { Condition } from 'Component/others';

export const tableListCamera = (onOpenPreview) => [
  {
    name: 'Waktu',
    width: 100,
    key: 'violationTime',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Jenis Pelanggaran',
    width: 500,
    key: 'violationType',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Keterangan',
    width: 200,
    key: 'screenshotUrl',
    component: ({ value, values }) => {
      const images = value ? [{ url: value }] : [];
      return (
        <Condition statement={value} fallback={<TextRegular className={styles['column__text']}>{values?.notes}</TextRegular>}>
          <AttachmentImage images={images} onOpenPreview={onOpenPreview} />
        </Condition>
      );
    },
  },
];
